import { atom } from 'recoil';

export default atom({
  key: 'isNotePlayerLoading',
  default: false,
});
